import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  :root {
    --base-background-color: ${({ theme }) => theme.colors.pageBackground};
  }
`
